import { IndexableObject } from "./Helpers";

export async function getProjectInfo(projectSlug: string): Promise<any | never> {
  return fetch("/api/projects/get-project-detail/" + projectSlug + "?status=none", {
    method: "GET",
  }).then((response) => {
    console.log(response);
    if (response.ok) {
      return response.json();
    }
    return Promise.reject(response);
  });
}

export function getAllComponentNames(target: object) {
  return Object.keys(target);
}

export async function getComponentData(projectSlug: string, development: boolean) {
  return fetch("/api/projects/" + projectSlug + "/components" + (development ? "?development=true" : ""), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then((response) => {
    console.log(response);
    try {
      if (response.ok) {
        return response.json();
      }
    } catch {
      return Promise.reject(new Error("Failed to load data"));
    }
    return Promise.reject(new Error("Failed to load data"));
  });
}

export async function saveComponentTree(projectSlug: string, development: boolean, treeData: IndexableObject) {
  return fetch("/api/projects/" + projectSlug + "/components" + (development ? "?development=true" : ""), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(treeData),
  }).then((response) => {
    if (response.ok) {
      return response;
    }
    return Promise.reject(new Error("Failed to save data"));
  });
}
